import { z } from 'zod';

import { positionDtoSchema } from '../position-geocode/position.dto.schema';

export const tourEventDtoSchema = z.object({
  id: z.number(),
  sequenceId: z.string(),
  name: z.string(),
  date: z.string(),
  position: positionDtoSchema.nullable(),
  capacity: z.number(),
  type: z.string(),
});

export const getTourEventsDtoSchema = z.object({
  data: z.array(tourEventDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type TourEventDto = z.infer<typeof tourEventDtoSchema>;

export const importTourEventDtoSchema = z.object({
  date: z.string(),
  name: z.string(),
  capacity: z.number(),
  position: positionDtoSchema.optional(),
});

export const importTourEventsFromOrfeoDtoSchema = z.array(
  importTourEventDtoSchema,
);

export type ImportTourEventDto = z.infer<typeof importTourEventDtoSchema>;
